import React from 'react';
import PropTypes from 'prop-types';
import { Animate } from '../Animate';
import { isDev } from '../Utils';

export const Collapsible = (props) => {
	const { transition: { duration = 300 } = {}, show } = props;
	return (
		<Animate
			show={show}
			duration={duration}
			animation={{ enter: 'slideIn', exit: 'slideOut' }}>
			<CollapsibleContent {...props} />
		</Animate>
	);
};

const CollapsibleContent = ({
	render,
	transition: { timingFunction = 'ease-in-out', duration = 300 } = {},
	colSpan,
	row,
	index,
	style,
	reference,
}) => (
	<tr data-role='expansion'>
		<td colSpan={colSpan} style={{ padding: 0 }}>
			<div
				ref={reference}
				style={{
					...style,
					transition: `height ${duration}ms ${timingFunction}`,
				}}>
				{render(row, index)}
			</div>
		</td>
	</tr>
);

if (isDev) {
	Collapsible.propTypes = {
		render: PropTypes.func,
		transition: PropTypes.shape({
			duration: PropTypes.number,
			timingFunction: PropTypes.string,
		}),
		colSpan: PropTypes.number,
		row: PropTypes.object,
		index: PropTypes.number,
	};
}
